import { ApiOutlined } from '@ant-design/icons';
import { Button, Card, Col, Empty, Popconfirm, Row, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAssigned } from '@client/store/assigned.store';
import { useDirty } from '@client/store/dirty.store';
import { useLoading } from '@client/store/loading.store';
import { useLocale } from '@client/store/locale.store';
import { flexLayout } from '@client/utils/layout.util';
import { type ECurrency, type ISubscription } from '@common/types';
import { numberToCurrency } from '@common/utils';

import styles from '../features.module.less';

type TFeatureSubscriptionsProps = {
  disabled?: boolean;
};

export const FeatureSubscriptions: React.FC<TFeatureSubscriptionsProps> = (
  props,
) => {
  const { t } = useTranslation();
  const { loading } = useLoading();
  const { setDirty } = useDirty();
  const { locale } = useLocale();

  const {
    assigned: assignedSubscriptions,
    setAssigned: setAssignedSubscriptions,
  } = useAssigned<ISubscription>();

  const { disabled = false } = props;

  const unAssign = (subscription: ISubscription) => {
    setAssignedSubscriptions(
      assignedSubscriptions.filter((s) => s.id !== subscription.id),
    );
    setDirty(true);
  };

  return (
    <>
      <Row gutter={[24, 24]}>
        {assignedSubscriptions.length ? (
          assignedSubscriptions?.map((subscription) => (
            <Col
              key={subscription.id}
              {...flexLayout.thirdColumn}
              className={styles.subscriptionCards}
            >
              <Card
                loading={loading}
                hoverable
                variant={'outlined'}
                extra={
                  <Button
                    icon={<ApiOutlined />}
                    color="danger"
                    variant="filled"
                    loading={loading}
                    disabled={disabled}
                  >
                    <Popconfirm
                      title={t('feature.msg.unAssignConfirm')}
                      disabled={disabled}
                      placement="topLeft"
                      onConfirm={() => {
                        unAssign(subscription);
                      }}
                    >
                      {t('actions.unAssign')}
                    </Popconfirm>
                  </Button>
                }
                title={
                  <Tooltip title={subscription.title}>
                    {subscription.title}
                  </Tooltip>
                }
              >
                <p>
                  {numberToCurrency(
                    subscription.price.originalPrice,
                    locale,
                    subscription.price.currency as ECurrency,
                  )}
                </p>
                <p>{subscription.description}</p>
              </Card>
            </Col>
          ))
        ) : (
          <Col span={24}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </Col>
        )}
      </Row>
    </>
  );
};
